import React from 'react';
import { Checkbox, Flex, Text } from '@marvelapp/ui';
import { SpecsPanel } from '@marvelapp/ui-internal';
import PanelPropertyItem from '../PanelPropertyItem';
export default function ColumnSettings(_a) {
    var totalWidth = _a.totalWidth, columnWidth = _a.columnWidth, offset = _a.offset, gutterWidth = _a.gutterWidth, count = _a.count, isGutterOnOutside = _a.isGutterOnOutside, isOverlayOn = _a.isOverlayOn, toggleOverlay = _a.toggleOverlay;
    return (React.createElement(SpecsPanel, { renderLink: function () { return (React.createElement(Checkbox, { isChecked: isOverlayOn, onChange: toggleOverlay, size: 16 },
            React.createElement(Text, { fontSize: 12, lineHeight: "16px" }, "Show overlay"))); }, title: "Columns" },
        React.createElement(Flex, { flexWrap: "wrap", marginBottom: -3 },
            React.createElement(PanelPropertyItem, { label: "Width" },
                totalWidth,
                "px"),
            React.createElement(PanelPropertyItem, { label: "Offset" },
                offset,
                "px"),
            React.createElement(PanelPropertyItem, { label: "Columns" }, count),
            React.createElement(PanelPropertyItem, { label: "Gutter" },
                gutterWidth,
                "px"),
            React.createElement(PanelPropertyItem, { label: "Column Width" },
                columnWidth,
                "px"),
            React.createElement(PanelPropertyItem, { fontFamily: 0, label: "Outside Gutter" }, isGutterOnOutside ? 'Yes' : 'No'))));
}
